module.exports = new __parcel__URL__("jpd-view-permission-lock-icon-spotlight-header.01172013.svg").toString();